import { CountryCode, parsePhoneNumber } from 'libphonenumber-js';

export const isValidPhoneNumber = (value: string, countryCode?: CountryCode) => {
    try {
        return parsePhoneNumber(value, countryCode).isValid();
    } catch {
        return false;
    }
};
